import { render, staticRenderFns } from "./OurCoaches.vue?vue&type=template&id=7c376aa3&scoped=true"
import script from "./OurCoaches.vue?vue&type=script&lang=js"
export * from "./OurCoaches.vue?vue&type=script&lang=js"
import style0 from "./OurCoaches.vue?vue&type=style&index=0&id=7c376aa3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c376aa3",
  null
  
)

export default component.exports